// extracted by mini-css-extract-plugin
export default {"container":"IngredeientDetails_container__hCC83","details":"IngredeientDetails_details__hewbO","pfc":"IngredeientDetails_pfc__9+N0e"};